module.exports = __webpack_public_path__ + "static/media/Trust-Badge-5.409c7681.png";